export default class GoogleMapsButtonControl {
  constructor (element, args) {
    let onclick = () => {
      if (!args.getValues) {
        return
      }

      let values = args.getValues()
      let data = values.filter((value) => {
        return value && value.trim && value.trim() !== ''
      })

      if (args.getValues().length === 0) {
        return
      }

      let locationString = data.join(', ')

      if (locationString) {
        open('//maps.google.com/?q=' + encodeURIComponent(locationString))
      } else {
        alert('Vul een geldig adres in.')
      }
    }

    let button = document.createElement('button')
    button.className = 'icon'
    button.innerHTML = '\ue0a6'
    button.onclick = onclick
    let fragment = document.createDocumentFragment()
    fragment.appendChild(button)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/GoogleMapsButtonControl.js